






import Vue, { PropType } from 'vue';
import lottie from 'lottie-web';

export type DataType = {
  anim: any;
}

export default Vue.extend({
  name: 'GLottie',
  data(): DataType {
    return {
      anim: null,
    };
  },
  props: {
    loop: { type: Boolean as PropType<boolean>, default: true },
    autoplay: { type: Boolean as PropType<boolean>, default: true },
    data: { type: Object as PropType<object>, required: true },
  },
  mounted() {
    const lavContainer: any = this.$refs.lavContainer;
    this.anim = lottie.loadAnimation({
      container: lavContainer,
      renderer: 'svg',
      loop: this.loop !== false,
      autoplay: this.autoplay !== false,
      animationData: this.data,
      // rendererSettings: this.options.rendererSettings
    });
    this.$emit('animCreated', this.anim);
  },
});
